import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Stack,
    Chip,
} from '@mui/material';
import RequestService from '../../services/RequestService';

const AdminDeleteContent = ({ open, onClose, content, onSuccess }) => {
    const handleSubmit = async () => {
        try {
            await RequestService.deleteContentAsSuperAdmin(content.id);
            onSuccess();
            onClose();
        } catch (err) {
            console.error('Failed to delete content:', err);
        }
    };

    if (!content) {
        return null;
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogContent sx={{ padding: '32px 32px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 24,
                            fontWeight: '500',
                            color: '#0C3466',
                            mb: 3,
                        }}
                    >
                        Excluir Missão
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 16,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 2,
                        }}
                    >
                        Tem certeza que deseja excluir este conteúdo? Essa ação
                        é irreversível e todos os dados associados a ele serão
                        perdidos.
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 1,
                        }}
                    >
                        Informações do Conteúdo
                    </Typography>
                    <Box
                        sx={{
                            padding: '24px 10px',
                            backgroundColor: '#EDF8FF',
                            borderRadius: '8px',
                        }}
                    >
                        <Stack direction="column" spacing={1}>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '500',
                                    color: '#292929',
                                }}
                            >
                                Título: {content.title}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '400',
                                    color: '#666666',
                                }}
                            >
                                Descrição:{' '}
                                {content.description || 'Não informado'}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '400',
                                    color: '#292929',
                                }}
                            >
                                Grupos:
                            </Typography>
                            <Stack direction="row" gap={2}>
                                {content.groups.map((group) => (
                                    <Chip
                                        key={group.id}
                                        label={group.name}
                                        size="small"
                                        color="primary"
                                    />
                                ))}
                                {content.groups.length > 3 && (
                                    <Chip
                                        label={`+ ${content.groups.length - 1}`}
                                        size="small"
                                        color="primary"
                                    />
                                )}
                            </Stack>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '400',
                                    color: '#292929',
                                }}
                            >
                                Jogos:
                            </Typography>
                            <Stack direction="row" gap={2}>
                                {content.games.map((game) => (
                                    <Chip
                                        key={game.id}
                                        label={game.name}
                                        size="small"
                                        color="primary"
                                    />
                                ))}
                                {content.games.length > 3 && (
                                    <Chip
                                        label={`+ ${content.games.length - 1}`}
                                        size="small"
                                        color="primary"
                                    />
                                )}
                            </Stack>
                        </Stack>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="error"
                    variant="contained"
                >
                    Excluir Conteúdo
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AdminDeleteContent;
